import React from 'react';
import { Flame } from '../../../Icon';
import styles from './BestValueBadge.module.scss';

export const BUTTON_LABEL = 'Best Value';

const BestValueBadge: React.FC = () => (
  <div className={styles.bestValueBtn}>
    <Flame fill="#fff" />
    <span>{BUTTON_LABEL}</span>
  </div>
);

export default BestValueBadge;
